import React from 'react';
import styles from './AdminMobileTabbtnBox.module.css';
import FlexChild from 'layouts/flex/FlexChild';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import P from 'components/P';
import { pageEH3FontSize } from 'routes/adminMobile/constraints/AdminConst';

const AdminMobileTabbtnBox = ({ categories, selectedCategory, setSelectedCategory }) => {
    // 버튼 클릭 핸들러
    const handleButtonClick = (categoryName) => {
        setSelectedCategory(categoryName);
    };

    return (
        <HorizontalFlex gap={10}>
            {/* categories 배열을 순회하여 각 카테고리에 대한 버튼 생성 */}
            {categories.map((category, index) => (
                <FlexChild key={index}>
                    {/* 선택된 카테고리인 경우에는 배경색을 변경 */}
                    <div
                        className={`${styles.button} ${selectedCategory === category.name && styles.selected}`}
                        onClick={() => handleButtonClick(category.name)}
                    >
                        <P size={pageEH3FontSize}>{category.text}</P>
                    </div>
                </FlexChild>
            ))}
        </HorizontalFlex>
    );
};

export default AdminMobileTabbtnBox;